module.exports = __webpack_public_path__ + "1b961af61613bd91011a476d5c7809b7.png";